import { createContext, useContext, useEffect, useState } from "react";

const KEY = "hq_lang";
const LanguageContext = createContext({ lang: "pt", setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem(KEY) : null;
    if (stored) return stored;
    const nav = (typeof navigator !== "undefined" ? navigator.language : "en").slice(0, 2);
    return ["pt", "en", "de", "fr", "it"].includes(nav) ? nav : "en";
  });

  const setLang = (l) => {
    setLangState(l);
    if (typeof window !== "undefined") localStorage.setItem(KEY, l);
  };

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
